import {  Row, Col, Button, Image } from "react-bootstrap"; 
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import mob from "../images/mob.png";
import photo from "../images/photo.png";
import MonashUniversity from "../images/MonashUniversity.svg";
import MelbourneUniversity from "../images/MelbourneUniversity.svg";
import AustralianGovernment from "../images/AustralianGovernment.svg";
import DeakinUniversity from "../images/DeakinUniversity.svg";
import RMITUniversity from "../images/RMITUniversity.svg";
import AucklandUniversity from "../images/AucklandUniversity.svg";
import React from "react";
import image from "../images/iphone3.png";
import arrowright from "../images/arrowright.png";
import { useInView } from "react-intersection-observer";


const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [animation, setAnimation] = useState(getRandomAnimation());

  function getRandomAnimation() {
    const animations = [
      { x: [-50, 0], opacity: [0, 1] },
      { x: [50, 0], opacity: [0, 1] },
      { y: [-50, 0], opacity: [0, 1] },
      { y: [50, 0], opacity: [0, 1] },
      
    ];
    return animations[Math.floor(Math.random() * animations.length)];
  }

  useEffect(() => {
    setAnimation(getRandomAnimation());
  }, []);

  return (
    <section 
      id="home" className="hero-section2 position-relative"
    >
      <div className="container mobcontainer">
        <Row className="">
          <Col md={6} className="py-5">
            <motion.img
                src={photo}
                alt="Decorative"
                className="decorative-image2"
                initial={{ scale: 0.8, opacity: 0, rotate: 0 }}
                whileInView={{ scale: [1.2, 1], opacity: 1, rotate: 360 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.3 }}
              />
            <motion.h1 
              className="mob-font-size text-white pe-5 pt-4"
              initial={{ opacity: 0, x: window.innerWidth < 768 ? 0 : -50 }}
              whileInView="visible" 
              viewport={{ once: false, amount: 0.3 }} 
              variants={{
                hidden: { opacity: 0 },
                visible: { opacity: 1, x: 0 } 
              }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <div className="we1">
                We specialise in building websites for Universities, Research Institutes and Schools.
              </div>
            </motion.h1>
          </Col>

          <Col md={6} className="">
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }} 
              whileInView={{ opacity: 1, scale: 1 }} 
              transition={{ duration: 1, ease: "easeInOut" }} 
              viewport={{ once: false, amount: 0.3 }}
            >
              {!isMobile ? (
                <Image src={image} alt="Mockup" className="w-100" fluid />
              ) : (
                <Image src={mob} alt="Mobile Mockup" className="mockup-image2 mobile-img" fluid />
              )}
            </motion.div>
          </Col>
        </Row>
        <Row className="">
        <div className="buttonOuter text-center">
      <button className="standoutbtn btn">
        <motion.span
          animate={{ opacity: [1, 0.7, 1] }}
          transition={{ duration: 0.7, repeat: Infinity, ease: "easeInOut" }}
        >
          STAND OUT
        </motion.span>
        <motion.div
        animate={{ x: [10, 0] }} // Moves from 20px right to 0px (left)
        transition={{ duration: 0.8, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }} 
        style={{ display: "inline-block", marginLeft: "8px" }}
      >
        <Image className="arrowstand" src={arrowright} alt="Mockup" fluid />
      </motion.div>

      </button>
    </div>
        </Row>
      </div>
      <section ref={ref} className="container-fluid TrustedClients">
      <Row>
        <Col className="ps-5">
          <p className="trusted-title text-uppercase text-white">
            OUR TRUSTED CLIENTS
          </p>
        </Col>
      </Row>

      <Row className="ourclients">
  {[
    MonashUniversity,
    MelbourneUniversity,
    AustralianGovernment,
    DeakinUniversity,
    RMITUniversity,
    AucklandUniversity,
  ].map((logo, index) => (
    <Col key={index} className="text-center">
      <motion.div
  initial={{ opacity: 0, x: window.innerWidth < 768 ? 0 : -50 }}
  whileInView={{ opacity: 1, x: 0 }} 
  viewport={{ once: false, amount: 0.2 }} 
  transition={{ duration: 0.6, delay: index * 0.2, ease: "easeInOut" }}
>
  <Image src={logo} alt="University Logo" className="" />
</motion.div>

    </Col>
  ))}
</Row>


    </section>
    

    </section>
  );
};

export default Hero;
